import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'HomeView',
  //   component: () => import('../views/HomeView.vue')
  // },
  // 首页
  {
    path: '/',
    // name: 'home',
    component: () => import('../views/HomeView.vue'),
    redirect: "home",
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home.vue'),
      },
      {
        path: '/test',
        name: 'test',
        component: () => import('../views/test.vue'),
      },
      // 联系我们页面
      {
        path: '/contactUs',
        name: 'contactUs',
        component: () => import('../views/lxwm.vue'),
      },
      // 关于魅服页面
      {
        path: '/aboutMF',
        name: 'aboutMF',
        component: () => import('../views/gymf.vue'),
      },
      // 服务页面
      {
        path: '/service',
        name: 'service',
        component: () => import('../views/fw/wxyw/fw.vue'),
      },
      // 解决方案页面 数控机床
      {
        path: '/solution',
        name: 'solution',
        component: () => import('../views/jjfa/hy/skjc.vue'),
      },
      // MES制造页面
      {
        path: '/MES',
        name: 'MES',
        component: () => import('../views/cp/qygl/MESxt.vue'),
      },
      // 多商户页面
      {
        path: '/merchant',
        name: 'merchant',
        component: () => import('../views/cp/dzsw/dsh.vue'),
      },
      // 集装箱页面
      {
        path: '/container',
        name: 'container',
        component: () => import('../views/cp/znwlycc/jzx.vue'),
      },
      // 智能物料柜页面
      {
        path: '/smartCabinet',
        name: 'smartCabinet',
        component: () => import('../views/cp/znwlycc/zng.vue'),
      },
      // 人脸识别页面
      {
        path: '/faceRecognition',
        name: 'faceRecognition',
        component: () => import('../views/rgzn/txsb/rlsb.vue'),
      },
      // 图像识别页面
      {
        path: '/imageRecognition',
        name: 'imageRecognition',
        component: () => import('../views/rgzn/txsb/txsb.vue'),
      },
      // 视觉搜索页面
      {
        path: '/visualSearch',
        name: 'visualSearch',
        component: () => import('../views/rgzn/txsb/sjss.vue'),
      },
      // 实时语音识别页面
      {
        path: '/realTimeSpeechRecognition',
        name: 'realTimeSpeechRecognition',
        component: () => import('../views/rgzn/yysb/ssyy.vue'),
      },
      // 录音文件识别页面
      {
        path: '/recordingFileRecognition',
        name: 'recordingFileRecognition',
        component: () => import('../views/rgzn/yysb/lywj.vue'),
      },
      // 语音分析页面
      {
        path: '/speechAnalysis',
        name: 'speechAnalysis',
        component: () => import('../views/rgzn/yysb/yyfx.vue'),
      },
       // 文字识别页面
       {
        path: '/characterRecognition',
        name: 'characterRecognition',
        component: () => import('../views/rgzn/OCRsb/wzsb.vue'),
      },
       // 企业资质页面
       {
        path: '/qualificationsIdentify',
        name: 'qualificationsIdentify',
        component: () => import('../views/rgzn/OCRsb/qyzz.vue'),
      },
       // 票据凭证页面
       {
        path: '/billVoucherIdentify',
        name: 'billVoucherIdentify',
        component: () => import('../views/rgzn/OCRsb/pjpz.vue'),
      },
       // 个人证照页面
       {
        path: '/personalIDIdentify',
        name: 'personalIDIdentify',
        component: () => import('../views/rgzn/OCRsb/grzz.vue'),
      },
      // O2O页面
      {
        path: '/O2OPlatform',
        name: 'O2OPlatform',
        component: () => import('../views/cp/dzsw/O2O.vue'),
      },
      // 智能货架页面
      {
        path: '/intelligentShelves',
        name: 'intelligentShelves',
        component: () => import('../views/cp/znwlycc/znhj.vue'),
      },
      // ERP页面
      {
        path: '/ERP',
        name: 'ERP',
        component: () => import('../views/cp/qygl/ERPxt.vue'),
      },
      // 数控学堂页面
      {
        path: '/CNCSchool',
        name: 'CNCSchool',
        component: () => import('../views/cp/jypx/skxt.vue'),
      },
      // 数控学堂页面
      {
        path: '/consulting',
        name: 'consulting',
        component: () => import('../views/fw/zxyy/xxhzy.vue'),
      },
      // 小程序直播页面
      {
        path: '/appletBroadcast',
        name: 'appletBroadcast',
        component: () => import('../views/fw/wxyw/xcxzb.vue'),
      },
      // 小程序直播页面
      {
        path: '/infrastructure',
        name: 'infrastructure',
        component: () => import('../views/fw/ITyw/jcjg.vue'),
      },
      // 集成企业管理系统页面
      {
        path: '/enterpriseManagement',
        name: 'enterpriseManagement',
        component: () => import('../views/fw/xtjc/qyglxt.vue'),
      },
       // 连接企业微信-钉钉页面
       {
        path: '/connectingEnterprises',
        name: 'connectingEnterprises',
        component: () => import('../views/fw/xtjc/ljqy.vue'),
      },
      // 定制化开发ERP插件页面
      {
        path: '/ERPplugInUnit',
        name: 'ERPplugInUnit',
        component: () => import('../views/fw/dzhkf/ERPcj.vue'),
      },
      // 定制网站页面
      {
        path: '/customWebsite',
        name: 'customWebsite',
        component: () => import('../views/fw/dzhkf/dzwz.vue'),
      },
      // 定制移动应用APP页面
      {
        path: '/customAPP',
        name: 'customAPP',
        component: () => import('../views/fw/dzhkf/dzAPP.vue'),
      },
      // 深度定制解决方案页面
      {
        path: '/deepCustomization',
        name: 'deepCustomization',
        component: () => import('../views/jjfa/ty/sddz.vue'),
      },
       // 企业数字化管理方案页面
       {
        path: '/enterpriseDigitization',
        name: 'enterpriseDigitization',
        component: () => import('../views/jjfa/ty/qyszh.vue'),
      },
      // 智慧门店页面
      {
        path: '/smartStore',
        name: 'smartStore',
        component: () => import('../views/jjfa/ty/zhmd.vue'),
      },
      // 数字孪生页面
      {
        path: '/digitalTwin',
        name: 'digitalTwin',
        component: () => import('../views/jjfa/ty/szls.vue'),
      },
       // 物联网VR页面
       {
        path: '/internetThingsVR',
        name: 'internetThingsVR',
        component: () => import('../views/jjfa/ty/wlwVR.vue'),
      },
      // 进销存管理页面
      {
        path: '/invoicingManagementSystem',
        name: 'invoicingManagementSystem',
        component: () => import('../views/cp/qygl/jxcgl.vue'),
      },
      // VR商城页面
      {
        path: '/VRmall',
        name: 'VRmall',
        component: () => import('../views/cp/dzsw/VRsc.vue'),
      },
      // 电商一体化页面
      {
        path: '/ECommerceIntegration',
        name: 'ECommerceIntegration',
        component: () => import('../views/jjfa/ty/dsyth.vue'),
      },
       // 智能仓储页面
       {
        path: '/intelligentWarehousing',
        name: 'intelligentWarehousing',
        component: () => import('../views/jjfa/ty/zncc.vue'),
      },
       // 汽车维修保养页面
       {
        path: '/automobileMaintenanceRepair',
        name: 'automobileMaintenanceRepair',
        component: () => import('../views/jjfa/hy/qcwxby.vue'),
      },
       // 数字广告页面
       {
        path: '/digitalAdvertising',
        name: 'digitalAdvertising',
        component: () => import('../views/jjfa/hy/szgg.vue'),
      },
      // 单商户页面
      {
        path: '/singleMerchant',
        name: 'singleMerchant',
        component: () => import('../views/cp/dzsw/dansh.vue'),
      },
      // CRM系统页面
      {
        path: '/CRM',
        name: 'CRM',
        component: () => import('../views/cp/qygl/CRMxt.vue'),
      },
      // SCM系统页面
      {
        path: '/SCM',
        name: 'SCM',
        component: () => import('../views/cp/qygl/SCMxt.vue'),
      },
      // 聚合广告页面
      {
        path: '/aggregatedAdvertising',
        name: 'aggregatedAdvertising',
        component: () => import('../views/cp/jypx/jhgg.vue'),
      },
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
